import moment from 'moment'

export default function deserializeCartState(cartState: App.SavedCheckoutReduxCartState): Partial<App.CheckoutCartState> {
  return {
    ...cartState,
    existingOrder: cartState.existingOrder ? {
      ...cartState.existingOrder,
      bedbankItems: cartState.existingOrder.bedbankItems.map(item => ({
        ...item,
        checkIn: moment(item.checkIn),
        checkOut: moment(item.checkOut)
      }))
    } : undefined
  }
}
